import React, { useEffect, useState } from 'react';
import Skeleton from '../OtherElements/CustomSkeleton';
import Select from 'react-select';
import API from '../../api/axios';

function SelectFleets(props) {
  const [fleets, setFleets] = useState(null);
  let { isMulti, onSelect, placeholder, fleet, isDisabled } = props;

  const loadFleets = async () => {
    try {
      const response = await API.get(`/api/v1/admin/fleet/list`);
      setFleets(response.data);
    } catch (err) {
      console.error(err);
    }
  };
  const handleSelectFleet = (fleets) => {
    onSelect(fleets);
  };

  useEffect(() => {
    loadFleets();
  }, []);

  return (
    <>
      {!!fleets ? (
        <Select
          options={fleets.map((fleet) => ({
            label: fleet.title,
            value: fleet._id,
          }))}
          isMulti={isMulti}
          isSearchable={true}
          placeholder={!!placeholder ? placeholder : 'انتخاب ناوگان'}
          value={fleet}
          onChange={(option) => handleSelectFleet(option)}
          noOptionsMessage={() => 'یافت نشد!'}
          isDisabled={isDisabled ? isDisabled : false}
        />
      ) : (
        <Skeleton height={30} />
      )}
    </>
  );
}

export default SelectFleets;
